<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'incidentSummary.cardTitle' | t }}</div>
    @if (summaryModel) {
        <div class="detail-page-card-actions">
            @if (summaryModel.canOpenParent) {
                <button
                    data-uiid="incident-moi-open-incident-button"
                    class="btn btn-raised"
                    (click)="openIncident()"
                >
                    <i class="fas fa-external-link-alt"></i>
                    <span>{{ 'incidentSummary.openIncidentBtn' | t }}</span>
                </button>
            }
        </div>
    }

    <div class="detail-page-card-body padded cerrix-control-sm form-group-styling">
        @if (summaryModel) {
            <div class="row">
                <div class="col-12 col-xl-6 left-block">
                    <div class="row">
                        <div class="col-3">
                            <div class="form-group">
                                <label>{{ 'incidentSummary.identifierLabel' | t }}</label>
                                <input
                                    data-uiid="incident-moi-identifier"
                                    type="text"
                                    class="form-control form-control-sm"
                                    disabled
                                    [value]="summaryModel.identifier"
                                    inputTooltip
                                />
                            </div>
                        </div>
                        <div class="col-9">
                            <div class="form-group">
                                <label>{{ 'incidentSummary.incidentNameLabel' | t }}</label>
                                <input
                                    data-uiid="incident-moi-name"
                                    type="text"
                                    class="form-control form-control-sm"
                                    disabled
                                    [value]="summaryModel.name"
                                    inputTooltip
                                />
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label>{{ 'incidentSummary.dateOccurredLabel' | t }}</label>
                                <date-input
                                    data-uiid="incident-moi-dateoccurred"
                                    [(value)]="summaryModel.date_Occurred"
                                    [disabled]="true"
                                ></date-input>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label>{{ 'incidentSummary.dateDetectedLabel' | t }}</label>
                                <date-input
                                    data-uiid="incident-moi-datedetected"
                                    [(value)]="summaryModel.date_Detected"
                                    [disabled]="true"
                                ></date-input>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-xl-6 right-block">
                    <div class="form-group">
                        <label>{{ 'incidentSummary.descriptionLabel' | t }}</label>
                        <textarea
                            data-uiid="incident-moi-description"
                            class="form-control form-control-sm"
                            disabled
                            [rows]="5"
                            [value]="summaryModel.description"
                            inputTooltip
                        ></textarea>
                    </div>
                </div>
            </div>
        } @else {
            <div class="fancy-loader submodule my-4"></div>
        }
    </div>
</div>
